
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/author/[id]",
      function () {
        return require("private-next-pages/magazine/author/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/author/[id]"])
      });
    }
  